.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  align-items: flex-start;
}

.heading {
  margin: 0;
}

.score {
  font-size: var(--tuna-typography-h2-fontSize);
  margin: 0;
}

.breakdown {
  margin: 0;
  padding-left: var(--tuna-spacing-4);
  color: var(--tuna-content-secondary);
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
}
